module.exports = __webpack_public_path__ + "static/media/nhsst.890ebbd9.png";